// extracted by mini-css-extract-plugin
module.exports = {"control":"print-report-detail-btn_control__CRAtk","btnPrint":"print-report-detail-btn_btnPrint__2WVJ1"};